const norm = (value) => String(value ?? "").trim().toLowerCase();

/**
 * Rule 34: the account's active operating currency to pre-fill for a selected country.
 * Returns the currency only when exactly one active currency lists the country, else null.
 * The API lists a currency's countries by name (+ flag_icon); `code` is honoured when present.
 */
export function resolveCurrencyForCountry({ currencies = [], countryCode = "", countries = [] } = {}) {
  const code = norm(countryCode);
  if (!code) return null;
  const countryName = norm((countries || []).find((c) => norm(c?.code) === code)?.name);

  const matches = (currencies || []).filter((currency) => {
    if (!currency || currency.active === false) return false;
    const listed = Array.isArray(currency.countries) ? currency.countries : [];
    return listed.some((c) => {
      if (norm(c?.code) === code) return true;
      return Boolean(countryName) && norm(c?.name) === countryName;
    });
  });

  return matches.length === 1 ? matches[0] : null;
}
